import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import Cross from 'components/Icons/Cross';
import GridView from 'components/Icons/GridView';
import TableView from 'components/Icons/TableView';
import { setDriver } from 'redux/PlanPageSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import { refetchPlanPageAfterInputPanelClose } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageFetchHelpers';

import DesktopPanel from '../ItemPage/DesktopPanel';
import TableViewComponent from '../ItemPage/DesktopPanel/TableView';

import type { PlanPageRefetchRequest } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageFetchHelpers';

interface Properties {
  longClickCheck: any;
  isLongClicked: boolean;
  refetchRequest: PlanPageRefetchRequest;
  onInputEdit: PlanPageRefetchRequest;
  orgChartType: number;
  updateOrg: (type: number) => void;
}

const LegacyOrganisationPanel = ({
  longClickCheck,
  isLongClicked,
  refetchRequest,
  onInputEdit,
  orgChartType,
  updateOrg,
}: Properties) => {
  const dispatch: AppDispatch = useDispatch();

  const closeSection = () => {
    refetchPlanPageAfterInputPanelClose(refetchRequest, { type: 'dimension' });
    dispatch(setDriver(null));
  };

  return (
    <Box height='100%'>
      <Flex justifyContent='space-between'>
        <Box display='flex' justifyContent='flex-end' padding='1rem'>
          <button type='button' onClick={() => updateOrg(2)}>
            <TableView selected={orgChartType === 2} />
          </button>
          <button type='button' onClick={() => updateOrg(1)}>
            <GridView selected={orgChartType === 1} />
          </button>
        </Box>
        <Flex justifyContent='end' padding='1rem'>
          <Cross onClick={closeSection} />
        </Flex>
      </Flex>
      {orgChartType === 1 ? (
        <TableViewComponent refetchRequest={onInputEdit} />
      ) : (
        <DesktopPanel
          orgType
          longClickCheck={longClickCheck}
          isLongClicked={isLongClicked}
          refetchRequest={onInputEdit}
        />
      )}
    </Box>
  );
};

export default LegacyOrganisationPanel;
